import { isThemingEnabled } from "@1js/acui-theme";

let modernUxExperimentPreference: boolean = false;

// Task 4473464 Clean-up 'ModernUxExperimentPreference' code from App Commanding UI Package
export const setModernUxExperimentPreference = (isEnabled: boolean) => {
  modernUxExperimentPreference = isEnabled;
};

export function getModernUxExperimentPreference(): boolean {
  return modernUxExperimentPreference && isThemingEnabled();
}
